import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTransaction, useUserContext } from '@dfx.swiss/react';
import { SpinnerSize, StyledLoadingSpinner, StyledVerticalStack } from '@dfx.swiss/react-components';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ErrorHint } from '../components/error-hint';
import { Layout } from '../components/layout';
import { BuyCompletion } from '../components/payment/buy-completion';
import { useSettingsContext } from '../contexts/settings.context';
import { useAddressGuard } from '../hooks/guard.hook';
import { useNavigation } from '../hooks/navigation.hook';
export function BuySuccessScreen() {
    const { translate } = useSettingsContext();
    const { navigate } = useNavigation();
    const { user } = useUserContext();
    const [params] = useSearchParams();
    const { getTransactionByCkoId } = useTransaction();
    const [error, setError] = useState();
    const ckoId = params.get('cko-payment-id');
    useAddressGuard('/', ckoId == null);
    useEffect(() => {
        if (ckoId)
            fetchCkoTx(ckoId);
    }, [ckoId]);
    function fetchCkoTx(id) {
        getTransactionByCkoId(id)
            .then((tx) => navigate({ pathname: `/tx/${tx.uid}` }, { clearParams: ['cko-payment-id', 'cko-session-id'] }))
            .catch((e) => { var _a; return e.statusCode === 404 ? setTimeout(() => fetchCkoTx(id), 3000) : setError((_a = e.message) !== null && _a !== void 0 ? _a : 'Unknown error'); });
    }
    return (_jsx(Layout, Object.assign({ title: translate('screens/buy', ckoId ? 'Buy' : 'Done!'), backButton: false, textStart: true }, { children: ckoId ? (_jsx(_Fragment, { children: error ? (_jsx(ErrorHint, { message: error })) : (_jsxs(StyledVerticalStack, Object.assign({ gap: 2, center: true }, { children: [_jsx(StyledLoadingSpinner, { size: SpinnerSize.LG }), _jsx("p", Object.assign({ className: "text-dfxGray-800" }, { children: translate('screens/buy', 'Waiting for the payment confirmation ... this may take a moment.') }))] }))) })) : (_jsx(BuyCompletion, { user: user, navigateOnClose: true })) })));
}
